interface HomePageMissionInfoProps {
  title?: string;
  description?: string;
}

export const HomePageMissionInfo = ({ description, title }: HomePageMissionInfoProps) => (
  <div className="w-full flex flex-col gap-6 sm:gap-8 items-start">
    {title && (
      <h1 className="max-w-full text-3xl sm:text-5xl lg:text-5xl xl:text-6xl 2xl:text-7xl text-left text-white leading-[1.05] font-outfit font-normal tracking-tight">
        {title}
      </h1>
    )}

    {description && (
      <div className="text-sm sm:text-lg text-left text-white leading-relaxed font-sans font-light tracking-normal">
        {description}
      </div>
    )}
  </div>
);
